/** @jsxImportSource @emotion/react */

import Layout from "components/Layout";
import Sidebar from "components/Layout/Sidebar";
import { useEffect, useState } from "react";
import { useSearchV3 } from "views/SearchV3/useSearchV3";
import SearchInput from "views/Browse/Search/SearchInput";
import BuilderResultRow from "views/SearchV3/BuilderResultRow";
import { Divider } from "views/Browse/Search/Divider";
import { useRootStore } from "store";
import LoadingFallback from "components/LoadingFallback";

const SearchV3 = () => {
  const {
    userStore: { isAdmin, user },
  } = useRootStore();

  const [submittedSearch, setSubmittedSearch] = useState("");

  const {
    data: searchResults,
    isFetching: isLoading,
    refetch,
  } = useSearchV3(submittedSearch);

  const handleSubmit = (value: string) => {
    if (value && value === submittedSearch) {
      refetch();
    } else {
      setSubmittedSearch(value);
    }
  };

  useEffect(() => {
    if (user && !isAdmin) {
      // Only admins can visit this route
      window.location.href = "/";
    }
  }, [isAdmin, user]);

  return (
    <Layout
      // ctaBlock={null}
      fullWidth={true}
      hideBackButton={true}
      sidebar={<Sidebar />}
    >
      {user ? (
        <div
          style={{
            padding: "0 40px",
            boxSizing: "border-box",
            maxWidth: 960,
            margin: "0 auto",
          }}
        >
          <h1>SearchV3</h1>

          <form
            onSubmit={(e) => e.preventDefault()}
            style={{ width: "100%", margin: "40px auto" }}
          >
            <SearchInput
              value={submittedSearch}
              onChange={handleSubmit}
              loading={isLoading}
            />
          </form>

          <Divider />

          <div style={{ margin: "20px auto", width: "100%" }}>
            {!isLoading && searchResults && (
              <div>
                {searchResults.results.map((result) => (
                  <BuilderResultRow
                    key={result.uid}
                    builder={result}
                    role={result.inferredRoleName}
                  />
                ))}
              </div>
            )}
            {isLoading && [1, 2, 3, 4].map((i) => <BuilderResultRow key={i} />)}
          </div>
        </div>
      ) : (
        <LoadingFallback />
      )}
    </Layout>
  );
};

export default SearchV3;
